// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app__modules_study_study_module_ts":"766625c68d3ff32b","src_app__modules_dashboard_dashboard_module_ts":"f71391b9271bba38","node_modules_dompurify_dist_purify_es_mjs":"ff26a30e7111be6f","node_modules_canvg_lib_index_es_js":"183ca2506e9542dc"}[chunkId] + ".js";
};